import { RegulationComponentsCommon } from "../../regulation-components-common";
import {
    LiveCasinoMinMaxBetComponentProps
} from "../../../../components/arena-host/new-live-casino-arena/live-casino-arena-grid/shared-components/live-casino-min-max-bet.component.props";

export class UKRegulationComponents extends RegulationComponentsCommon {
    renderLiveCasinoMinMaxBet(props: LiveCasinoMinMaxBetComponentProps): React.ReactElement {
        // if slot game - turn on isHideMaxBet flag
        const isLiveSlot = this.services.liveTableFeeds.getIsLiveSlotGroup(props.gameInfo.subGroupName);
        return super.renderLiveCasinoMinMaxBet({
            ...props,
            isHideMaxBet: isLiveSlot
        });
    }
}